import { render, staticRenderFns } from "./download-page.vue?vue&type=template&id=c2d8a1e6&scoped=true&"
import script from "./download-page.vue?vue&type=script&lang=js&"
export * from "./download-page.vue?vue&type=script&lang=js&"
import style0 from "./download-page.vue?vue&type=style&index=0&id=c2d8a1e6&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8a1e6",
  null
  
)

export default component.exports